import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuthStore } from '../stores/authStore';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { isAuthenticated, userRole, user, authResolved } = useAuthStore();
  const location = useLocation();
  const resolvedRole = userRole || user?.role;

  if (!authResolved) {
    return (
      <Box sx={{ minHeight: '60vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: `${location.pathname}${location.search}${location.hash}` }} replace />;
  }

  if (!resolvedRole || !['SUPER_ADMIN', 'CONTENT_MODERATOR', 'FINANCE_ADMIN', 'SUPPORT_ADMIN', 'ID_VERIFICATION_ADMIN'].includes(resolvedRole)) {
    return <Navigate to="/my-profile" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
